import { Box, Typography } from '@mui/material';

import { getThemeColor } from '../../utils/common';
import FCheckbox from './FCheckbox';
import { FORTA_WHITE } from '../../utils/colors';

import type { Themes } from '../../constants';
import type { ReactNode } from 'react';

interface IFCheckboxListItemProp {
  id: number | string;
  label?: string;
  checked: boolean;
  colorTheme: Themes;
  contentRenderer?: (id: number | string, label: string | undefined, checked: boolean) => ReactNode;
  onChange: (id: number | string, checked: boolean) => void;
  dataTestId?: string;
}

const FHCheckboxListItem = ({
  id,
  label,
  checked = false,
  colorTheme,
  contentRenderer,
  onChange,
  dataTestId,
}: IFCheckboxListItemProp) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }} mb={2}>
      <Box mt={-1}>
        <FCheckbox
          data-testid={dataTestId}
          checked={checked}
          onChange={(e) => onChange(id, e.target.checked)}
          colorTheme={colorTheme}
          coloredBackground
        />
      </Box>
      <Box
        sx={{
          borderRadius: '10px',
          backgroundColor: checked ? getThemeColor(colorTheme).primary : FORTA_WHITE,
          padding: {
            xs: 1,
            sm: 2,
          },
          border: `2px solid ${getThemeColor(colorTheme).primary}`,
          color: checked ? FORTA_WHITE : `${getThemeColor(colorTheme).primary}`,
          flexGrow: 1,
          overflowY: 'auto',
        }}
      >
        {contentRenderer ? (
          contentRenderer(id, label, checked)
        ) : (
          <Typography noWrap>{label}</Typography>
        )}
      </Box>
    </Box>
  );
};

export default FHCheckboxListItem;
